import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, mergeProps as _mergeProps, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

import { computed, ref } from "vue";
import { ArtifactTypeSchema, TypeButtonProps } from "@/types";
import { timStore } from "@/hooks";
import { IconButton, Separator } from "@/components/common";


/**
 * Buttons for selecting artifact types.
 */
const __default__ = {
  name: "TypeButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    defaultVisible: { type: Boolean },
    hiddenTypes: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(props.defaultVisible || false);

const artifactTypes = computed(() => timStore.artifactTypes);

/**
 * Returns props for a type button.
 * @param option - The type button to get props for.
 */
function buttonProps(option: ArtifactTypeSchema) {
  const hidden = props.hiddenTypes.find((type) => type === option.name);

  return {
    style: `color: ${option.color};` + (hidden ? "opacity: 0.3" : ""),
    tooltip: option.name,
    class: !hidden ? "bg-background" : "",
  };
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    bordered: visible.value,
    flat: "",
    class: _normalizeClass(
      visible.value ? 'bd-text bg-transparent' : 'bd-transparent bg-transparent'
    )
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_btn_group, { flat: "" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artifactTypes.value, (type) => {
            return _withDirectives((_openBlock(), _createBlock(_unref(IconButton), _mergeProps({
              key: type.typeId
            }, buttonProps(type), {
              dense: "",
              "tooltip-delay": 0,
              "icon-id": _unref(timStore).getTypeIcon(type.name),
              color: _unref(timStore).getTypeColor(type.name, true),
              "data-cy": "button-filter-type",
              onClick: ($event: any) => (emit('click', type, artifactTypes.value))
            }), null, 16, ["icon-id", "color", "onClick"])), [
              [_vShow, visible.value]
            ])
          }), 128)),
          _withDirectives(_createVNode(_unref(Separator), {
            vertical: "",
            color: "text"
          }, null, 512), [
            [_vShow, visible.value]
          ]),
          _createVNode(_unref(IconButton), {
            dense: "",
            tooltip: "Filter Types",
            color: "text",
            icon: visible.value ? 'filter-close' : 'filter-open',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = !visible.value))
          }, null, 8, ["icon"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["bordered", "class"]))
}
}

})